import './pugImport';
import '../css/au/base.scss';
import '../css/uq/base.scss';
import '../css/auuq/base.scss';

import './app/app';

// HMRに失敗してもJSがリロードしてくれないので強制的にリロードを実行する
if (module.hot) {
  module.hot.accept(console.error);
  module.hot.dispose(() => {
    window.location.reload();
  });
}
